import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom'

import classnames from 'classnames';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';

import Button from '@material-ui/core/Button';
import red from '@material-ui/core/colors/red';
import blue from '@material-ui/core/colors/blue';

import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import HighlightIcon from '@material-ui/icons/Highlight';
import AddCommentIcon from '@material-ui/icons/Comment';
import PinDropIcon from '@material-ui/icons/PinDrop';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

const styles = theme => ({
    card: {
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    actions: {
        display: 'flex',
    },
    expand: {
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        })
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    avatar: {
        backgroundColor: blue[500],
        width: 60,
        height: 60,
    },
});

const options = [
    'Not interested',
    'More like this!',
    'Why am I seeing this?'
];

const ITEM_HEIGHT = 48;

const getDiff = (timestamp) => {
    return moment().diff(moment(timestamp), 'hours') + ' hours ago';
}

class ExpandableCard extends React.Component {
    state = { expanded: false, anchorEl: null, };

    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    handleExpandClick = () => {
        this.setState({ expanded: !this.state.expanded });
    };

    render() {
        const { anchorEl } = this.state;
        const { classes, content, defaultStyle } = this.props;
        const leftColSize = content.thumbnail ? 6 : 0;
        const rightColSize = content.thumbnail ? 6 : 12;
        return (
            <div>
                <Menu
                    id="long-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose}
                    PaperProps={{
                        style: {
                            maxHeight: ITEM_HEIGHT * 4.5,
                            width: 200,
                        },
                    }}
                >
                    {content.openDetail ?
                        <MenuItem key="detaul" onClick={() => { this.props.history.push(content.openDetail.url); this.handleClose }}>
                            See details
                        </MenuItem> : null}
                    {options.map(option => (
                        <MenuItem key={option} selected={option === 'Pyxis'} onClick={this.handleClose}>
                            {option}
                        </MenuItem>
                    ))}
                </Menu>
                <Card className={classes.card} style={defaultStyle}>
                    <CardHeader
                        avatar={
                            <Avatar src={content.avatar ? content.avatar.pic : null} aria-label={content.avatar ? content.avatar.name : "AI"} className={classes.avatar}>
                                {!content.avatar ? <img src="/altolan.png" width="60px" /> : null}
                            </Avatar>
                        }
                        action={
                            <IconButton
                                aria-label="More"
                                aria-owns={anchorEl ? 'long-menu' : null}
                                aria-haspopup="true"
                                onClick={this.handleClick}
                            >
                                <MoreVertIcon />
                            </IconButton>
                        }
                        title={<Typography variant="title"><span dangerouslySetInnerHTML={{ __html: content.title }}></span></Typography>}
                        subheader={getDiff(content.timestamp)}
                    />
                    <Grid container spacing={24}>
                        <Grid item xs={leftColSize} sm={leftColSize}>
                            {content.thumbnail ? <CardMedia
                                className={classes.media}
                                image={content.thumbnail}
                                title={<span dangerouslySetInnerHTML={{ __html: content.title }}></span>}
                            /> : null}
                        </Grid>
                        <Grid item xs={rightColSize} sm={rightColSize}>
                            <CardContent>
                                <Typography variant="subheading">
                                    <span dangerouslySetInnerHTML={{ __html: content.description }}></span>
                                </Typography>
                            </CardContent>
                        </Grid>
                    </Grid>
                    <CardActions className={classes.actions} disableActionSpacing>
                        {content.recommendation ?
                            <IconButton
                                className={classnames(classes.expand, {
                                    [classes.expandOpen]: this.state.expanded,
                                })}
                                onClick={this.handleExpandClick}
                                aria-expanded={this.state.expanded}
                                aria-label="Show more"
                            >
                                <HighlightIcon />
                            </IconButton> : null}
                        <IconButton aria-label="Pin this">
                            <PinDropIcon />
                        </IconButton>
                        <IconButton aria-label="Share">
                            <ShareIcon />
                        </IconButton>
                        <IconButton aria-label="Comment">
                            <AddCommentIcon />
                        </IconButton>
                        <Chip label={content.category} style={{ marginLeft: 'auto' }} />
                    </CardActions>
                    {content.recommendation ?
                        <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
                            <CardContent>
                                <Typography variant="subheading" gutterBottom>
                                    Recommendation: <span dangerouslySetInnerHTML={{ __html: content.recommendation }}></span>
                                </Typography>
                                {content.action ? <Button variant="outlined" size="medium" color="primary" onClick={() => this.props.history.push(content.action.url)}>
                                    {content.action.label}
                                </Button> : null}
                            </CardContent>
                        </Collapse> : null}
                </Card>
                <br />
            </div>
        );
    }
}

ExpandableCard.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles)(ExpandableCard));


// WEBPACK FOOTER //
// ./src/components/cards/ExpandableCard.js